<template>
    <FormSection
        title="Primary Emergency Contact"
        type="his-section"
        :full-height="false"
        :application-id="Number(application)"
    >
        <template #content>
            <div class="col col-12">
                <section class="row py-3 px-4 g-0">
                    <div class="col-12 col-lg-6 px-4 col-md-12 g-0">
                        <div class="col-12 py-2">
                            <div class="row col-12">
                                <div class="form-group col-12 col-lg-6">
                                    <label id="contact_first_name" for="contact_first_name">
                                        First Name<span class="text-danger" v-if="isFieldRequired">*</span>
                                    </label>
                                    <input
                                        id="contact_first_name"
                                        name="contact_first_name"
                                        class="form-control"
                                        :class="`form-control ${
                                            v$.referral.Contacts.PrimaryEmergencyContact.FirstName.$error ||
                                            errors.Contacts.includes('FirstName')
                                                ? 'border border-warning'
                                                : ''
                                        }`"
                                        maxlength="50"
                                        type="text"
                                        placeholder="Enter First Name"
                                        v-model="referral.Contacts.PrimaryEmergencyContact.FirstName"
                                        @blur="v$.referral.Contacts.PrimaryEmergencyContact.FirstName.$touch"
                                        @change="(e) => handleAllInputChange('FirstName', e.target.value)"
                                    />
                                </div>
                                <div class="form-group col-12 col-lg-6">
                                    <label for="contact_last_name"
                                        >Last Name<span class="text-danger" v-if="isFieldRequired">*</span></label
                                    >
                                    <input
                                        name="contact_last_name"
                                        :class="`form-control ${
                                            v$.referral.Contacts.PrimaryEmergencyContact.LastName.$error ||
                                            errors.Contacts.includes('LastName')
                                                ? 'border border-warning'
                                                : ''
                                        }`"
                                        type="text"
                                        maxlength="50"
                                        placeholder="Enter Last Name"
                                        v-model="referral.Contacts.PrimaryEmergencyContact.LastName"
                                        @blur="v$.referral.Contacts.PrimaryEmergencyContact.LastName.$touch"
                                        @change="(e) => handleAllInputChange('LastName', e.target.value)"
                                    />
                                </div>
                            </div>
                            <div class="form-group col-12 col-lg-12 pe-lg-2">
                                <label for="contact-mobile-number">
                                    Mobile Phone
                                    <i
                                        class="fas fa-question-circle"
                                        v-tooltip="{
                                            title: `For emergency preparedness, patient will be contacted at this number. This will also populate to the emergency preparedness report.`,
                                            placement: 'right'
                                        }"
                                    ></i>
                                    <span class="text-danger" v-if="isFieldRequired">*</span>
                                </label>
                                <input
                                    id="contact-mobile-number"
                                    type="text"
                                    :class="`form-control phone-number-input ${
                                        v$.referral.Contacts.PrimaryEmergencyContact.PrimaryPhone.$error ||
                                        errors.Contacts.includes('PrimaryPhone')
                                            ? 'border border-warning'
                                            : ''
                                    }`"
                                    :maxlength="10"
                                    placeholder="Enter Number"
                                    v-number-only
                                    v-model="referral.Contacts.PrimaryEmergencyContact.PrimaryPhone"
                                    @blur="v$.referral.Contacts.PrimaryEmergencyContact.PrimaryPhone.$touch"
                                    @change="(e) => handleAllInputChange('PrimaryPhone', e.target.value)"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-12 pe-lg-2">
                                <label for="contact-alternate-mobile"> Alternate Phone </label>
                                <input
                                    id="contact-alternate-mobile"
                                    type="text"
                                    class="form-control phone-number-input"
                                    :maxlength="10"
                                    placeholder="Enter Number"
                                    v-number-only
                                    v-model="referral.Contacts.PrimaryEmergencyContact.AlternatePhone"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-12 pe-lg-2">
                                <label for="contact_relationship"> Relationship</label>
                                <select
                                    class="form-select"
                                    v-model="referral.Contacts.PrimaryEmergencyContact.RelationOption"
                                >
                                    <option :value="0">Select Relationship</option>
                                    <option
                                        v-for="(relation, index) of referralOptions?.relation"
                                        :key="index"
                                        :value="relation.value"
                                    >
                                        {{ relation.text }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group col-12 col-lg-12 pe-lg-2">
                                <label for="auth-contact-rel-desc"> Other </label>
                                <input
                                    name="auth-contact-rel-desc"
                                    class="form-control"
                                    type="text"
                                    placeholder="Enter Relationship"
                                    v-model="referral.Contacts.PrimaryEmergencyContact.Relationship"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-12 pe-lg-2">
                                <label for="contact-email"> Email </label>
                                <input
                                    name="contact-email"
                                    class="form-control"
                                    maxlength="50"
                                    type="text"
                                    placeholder="Enter Email Address"
                                    v-model="referral.Contacts.PrimaryEmergencyContact.EmailAddress"
                                />
                            </div>
                        </div>
                        <div class="col-12 py-2 ms-3">
                            <p>Representative</p>
                            <div class="form-check custom-checkbox">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    id="Legal Representative"
                                    :value="1"
                                    v-model="referral.Contacts.PrimaryEmergencyContact.LegalRepresentative"
                                />
                                <label class="form-check-label" for="Legal Representative">
                                    Legal Representative
                                </label>
                            </div>
                            <div class="form-check custom-checkbox">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    id="Patient Selected Representative"
                                    :value="2"
                                    v-model="referral.Contacts.PrimaryEmergencyContact.PatientSelectedRepresentative"
                                />
                                <label class="form-check-label" for="Patient Selected Representative">
                                    Patient Selected Representative
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 px-4 col-md-12 g-0 mt-2">
                        <div class="w-100">
                            <div class="form-check custom-checkbox">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    id="contact-address"
                                    v-model="referral.Contacts.SameAsPatientAddress"
                                    @change="setSameAsPatient()"
                                />
                                <label class="form-check-label" for="contact-address"> Same as Patient Address </label>
                            </div>
                        </div>
                        <div class="row">
                            <ReferralAddressForm
                                :address="referral.Contacts.PrimaryEmergencyContact.Address"
                                addressType="PrimaryEmergencyContact"
                                :zipChanged="handleZipChange"
                                :county-data="primaryEmergency"
                            />
                        </div>
                    </div>
                </section>
            </div>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./EmergencyContactPrimary.ts"></script>
